export const Button = (props) => {
    let {
        name,
        action,
        type,
        id,
        padding,
        isVisible,
        title,
        customCN,
        disabled,
        buttonType,
        loading,
    } = props;

    const isLoading = !!loading;

    if (isVisible === undefined) {
        isVisible = true;
    }

    const className = () => {
        let cn =
            "max-h-12 font-bold py-2 px-4 focus:outline-hidden focus:shadow-outline whitespace-nowrap ";

        const isDisabled = (disabled || type === "disabled") && !isLoading;
        if (isDisabled) {
            cn += "cursor-not-allowed rounded-sm border-2 border-slate-300 bg-grey-700 text-slate-300";
            return cn;
        }

        switch (type) {
            case "empty":
                cn += "cursor-pointer rounded-sm border-2 border-app-primary text-app-primary hover:border-app-secondary hover:text-app-secondary ";
                break;

            case "test":
                cn += "cursor-pointer rounded-sm border-2 border-app-secondary text-app-secondary hover:border-app-primary hover:text-app-primary";
                break;

            case "red":
                cn += "cursor-pointer rounded-sm border-2 border-red-700 bg-red-700 hover:border-red-400 hover:bg-red-400 text-white";
                break;

            case "disabled":
                cn += "cursor-not-allowed rounded-sm border-2 border-slate-300 bg-grey-700 text-slate-300";
                break;

            case "custom":
                cn = customCN || "cursor-pointer rounded-sm border-2 border-app-primary bg-app-primary hover:border-app-secondary hover:bg-app-secondary text-white";
                break;

            default:
                cn +=
                    "cursor-pointer rounded-sm border-2 border-app-primary bg-app-primary hover:border-app-secondary hover:bg-app-secondary text-white";
                break;
        }
        if (isLoading) {
            cn += " cursor-wait opacity-90";
        }
        return cn;
    };

    return (
        <>
            {isVisible && (
                <button
                    id={id}
                    type={buttonType}
                    onClick={
                        disabled || type === "disabled" || isLoading
                            ? undefined
                            : action
                    }
                    disabled={
                        !!disabled || type === "disabled" || isLoading
                    }
                    className={className()}
                    data-secret={props["data-secret"] && props["data-secret"]}
                    title={title || ""}
                    aria-busy={isLoading ? true : undefined}
                >
                    {isLoading ? (
                        <span className="inline-flex items-center justify-center gap-2">
                            <span
                                className="inline-block h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-current border-r-transparent"
                                aria-hidden
                            />
                            {name}
                        </span>
                    ) : (
                        name
                    )}
                </button>
            )}
        </>
    );
};
